import React, { useContext } from "react";

export type BundlePickerV3ContextValue = {
  featureFlags: {
    "upsell.v1.guest"?: boolean;
  };
};
export const BundlePickerV3Context =
  React.createContext<BundlePickerV3ContextValue>({
    featureFlags: {},
  });

export type BundlePickerV3Provider = BundlePickerV3ContextValue;
export function BundlePickerV3Provider({
  children,
  ...props
}: BundlePickerV3ContextValue & React.PropsWithChildren) {
  return <BundlePickerV3Context.Provider value={props} children={children} />;
}

export function useBundlePicker() {
  return useContext(BundlePickerV3Context);
}
